import { useMutation, useQueryClient } from 'react-query'

import { putUserCountry } from 'services/endpoints/profile'

interface useCountryMutationProps {
    nextStep?: () => void
}
export function useCountryMutation({ nextStep }: useCountryMutationProps) {
    const queryClient = useQueryClient()
    const countryMutation = useMutation(
        async (countryId: number) => await putUserCountry(countryId),
        {
            onMutate: () => {},
            onSettled: () => {
                queryClient.invalidateQueries('user-profile')
                nextStep?.()
            }
        }
    )
    return { countryMutation }
}
